// @flow

import { Button } from 'reshaped';

import { selectCartIsWorking } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from '../../../hooks/useAppSelector';
import { useQuote } from '../../hooks/useQuote';

export function SubmitButton(): React.MixedElement | null {
  const { __ } = useTranslator();

  const { options } = useQuote();

  const isWorking = useAppSelector(selectCartIsWorking);

  if (!options.length) return null;

  return (
    <Button
      type="submit"
      color="primary"
      size="large"
      loading={isWorking}
      attributes={{ style: { alignSelf: 'end' } }}
    >
      {__('Continue')}
    </Button>
  );
}
